/** Single source of truth for Matlist's interaction feel. Colours and fonts live in brand/ CSS, not here. */
export const SWIPE = {
  slopPx: 6,
  armPx: 110,
  flickVelocityPxPerMs: 0.55,
  flickMinPx: 36,
  /** Width of the revealed Delete button; a left swipe past half of it opens the row. */
  revealPx: 88,
  /** Full-swipe delete: whichever is larger, an absolute distance or a share of the row width. */
  fullDeleteMinPx: 160,
  fullDeleteRatio: 0.55,
  /** Undo window after any delete. */
  undoMs: 5000,
} as const

/** Crisp, sporty motion: ease-out, no overshoot, no tilt. */
export const MOTION = {
  easeOut: 'cubic-bezier(.2,.8,.2,1)',
  slideOut: { ms: 280, easing: 'cubic-bezier(.4,0,1,1)', to: 'translateX(110%)' }, // basket: row leaves to the right
  deleteSlideOut: { ms: 220, easing: 'ease-in' },
  snapBack: { ms: 300, easing: 'cubic-bezier(.2,.8,.2,1)' },
  settleIn: { ms: 260, easing: 'cubic-bezier(.2,.8,.2,1)', fromY: -6 },
  chipOut: { ms: 220, addAfterMs: 200 },
  basketTick: { ms: 160, scale: 1.03 },
  sheet: { ms: 320, easing: 'cubic-bezier(.2,.8,.2,1)' },
  dialog: { ms: 220, fromScale: 0.97 },
  progress: { ms: 300 }, // segment colour change
  splash: { drawMs: 560, drawDelayMs: 100, drawEasing: 'cubic-bezier(.6,0,.2,1)', wordDelayMs: 340, wordMs: 300, totalMs: 1100 },
  reducedMotionFadeMs: 150,
} as const

export const HAPTICS = {
  arm: 8,
  drop: [10, 30, 16],
  chip: 10,
  categoryPick: 6,
  remove: 20,
  reveal: 6,
  finishTrip: [12, 40, 12, 40, 20],
} as const

/** Below 900 px: phone (shop). From 900 px: desktop (plan), 3 card columns from 1280 px. */
export const BREAKPOINTS = { desktop: 900 } as const

// A tick older than this counts as an earlier trip that nobody finished: the
// app finishes it on open (GroceryList), and 032_finish_stale_baskets.sql did
// the same once for the old "ticked stays on the list" backlog.
export const STALE_BASKET_MS = 12 * 60 * 60 * 1000

// Running low (lib/restock.ts). minPurchases counts trips; past staleFactor ×
// the interval a thing is taken as no longer bought. The order is
// min(overdue, urgencyCap) × n / (n + regularityPrior): how due, times how sure
// it is a habit after n trips.
export const RESTOCK = {
  minPurchases: 2, dueFactor: 0.85, overdueFactor: 1.5, staleFactor: 3, urgencyCap: 1.5, regularityPrior: 2, max: 8,
} as const
